import { useCallback } from "react";
import {
  Container,
  Row,
  Form,
  FloatingLabel,
  Button,
  Spinner,
  Image,
} from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import styles from "./loginPage.module.scss";
import loginPageSlice from "./store/slice";
import Logo from "../../images/logo-colour.svg";
import { Link } from "react-router-dom";
import moment from "moment";

export type LoginFormValues = {
  email: string;
  password: string;
};

const LoginPage = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.loginPage.isLoading);

  const login = useCallback(
    (data: LoginFormValues) => dispatch(loginPageSlice.actions.login(data)),
    [dispatch]
  );

  const {
    formState: { errors },
    register,
    handleSubmit,
  } = useForm<LoginFormValues>();

  const onSubmit: SubmitHandler<LoginFormValues> = (data) => {
    login(data);
  };

  return (
    <Container fluid className={styles.container}>
      <Row className={styles.row}>
        <Form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
          <Image alt="logo" src={Logo} className={styles.logo} />

          <FloatingLabel
            controlId="email"
            label="Email address"
            className="mb-3"
          >
            <Form.Control
              type="email"
              placeholder="Email address"
              isInvalid={!!errors.email}
              {...register("email", {
                required: true,
              })}
              maxLength={100}
              disabled={isLoading}
            />
          </FloatingLabel>
          <FloatingLabel controlId="password" label="Password">
            <Form.Control
              type="password"
              placeholder="Password"
              isInvalid={!!errors.password}
              {...register("password", {
                required: true,
              })}
              maxLength={100}
              disabled={isLoading}
            />
          </FloatingLabel>

          <Button
            type="submit"
            size="lg"
            className={styles.submit}
            disabled={isLoading}
          >
            Sign in
            {isLoading && (
              <Spinner
                size="sm"
                animation="border"
                className={styles.spinner}
              />
            )}
          </Button>

          <div className={styles.forgot}>
            <Link to="/forgot-password">Forgot password?</Link>
          </div>

          <hr />

          <div className={styles.register}>
            <span>Don't have an account?</span>
            <Link to="/register">
              <Button variant="outline-secondary">Register</Button>
            </Link>
          </div>

          <div className={styles.manager}>
            Join if you are Girteka manager
            <a href="/login/microsoft">here</a>.
          </div>

          <p className={styles.copyright}>
            © {moment().format("YYYY")} Girteka Competence Center
          </p>
        </Form>
      </Row>
    </Container>
  );
};

export default LoginPage;
